The image options for the Apply with SEEK button.
